import BaseObject from "../../base/base_object";
import {MESSAGES_SOURCE} from "./player_messages_consts";
import MainProxyStrategy from './main/main_proxy_strategy';
import FirebaseStrategy from "./firebase/firebase_strategy";

export default class PlayerMessagesFactory extends BaseObject {
    static CLASS = 'PlayerMessagesFactory';

    createMessageSourceComponent(source, sourceParams, dependensies) {
        let component;
        switch (source) {
            case MESSAGES_SOURCE.FIREBASE:
                component = FirebaseStrategy.create(Object.assign({}, sourceParams.Firebase, dependensies));
                break;
            case MESSAGES_SOURCE.MAIN_PROXY:
                component = MainProxyStrategy.create(Object.assign({}, sourceParams.MainProxy, dependensies));
                break;
            default:
                component = FirebaseStrategy.create(Object.assign({}, sourceParams.Firebase, dependensies));
                component.start();
                break;
        }

        return component;
    }


}